import { useQueryClient } from '@tanstack/react-query';

import { Entity } from 'models';

import { useMutation } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { getChannelsFeatureQueryKey } from 'features/channels/queries/keys';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { getNodeOrganizationsInfiniteQueryKey } from 'features/organizations/queries/keys';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { getProfileQueryKey } from 'features/users/queries/keys';
import { leaveCommunity } from '../../services';
import { getCommunitiesInfiniteQueryKey, getCommunityQueryKey } from '../keys';

// TODO should not invalidate all communities, make invalidate correct ones (List type / Detail)
export const useLeaveCommunityMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<Entity, { id: string }>({
    async mutationFn({ id }) {
      const communityResponse = await leaveCommunity({ id });

      return new Entity(communityResponse.data);
    },
    async onError() {
      await queryClient.invalidateQueries({ queryKey: getCommunityQueryKey({}) });
      // TODO this will be removed with useCommunityDataObjectQuery
      await queryClient.invalidateQueries({ queryKey: ['data-object', ...getCommunityQueryKey({})] });
    },
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: getCommunityQueryKey({}) });
      // TODO this will be removed with useCommunityDataObjectQuery
      await queryClient.invalidateQueries({ queryKey: ['data-object', ...getCommunityQueryKey({})] });
      await queryClient.invalidateQueries({ queryKey: getCommunitiesInfiniteQueryKey({}) });
      await queryClient.invalidateQueries({ queryKey: getChannelsFeatureQueryKey() });
      await queryClient.invalidateQueries({ queryKey: getProfileQueryKey() });
      await queryClient.invalidateQueries({ queryKey: getNodeOrganizationsInfiniteQueryKey({}) });
    },
  });
};
